// The lane band: the forecast lane is a fixed-height band under the forecast header, with the
// signposts table below it. Pure layout numbers and helpers; no React.

/** Distance from the band's top to the spine: room for the Today/Resolves labels and one row of
 *  trigger labels above the line. */
export const LANE_SPINE_Y = 96;
/** Room below the spine: a row of trigger labels, the outcome bars, and the legend row. */
export const LANE_BELOW_SPINE = 104;

/**
 * The band's height: the lane's own content (scenario rows stack below the spine) up to 60% of
 * the space under the header; past that the band scrolls.
 *
 * @param {object} p
 * @param {number} p.contentBottom  bottom of the lane's row stack (stackedLaneLayout's
 *   totalHeight, which already includes the last row's own extent)
 * @param {number} p.available      height of the timeline column below the header
 */
export function laneBandHeight({ contentBottom, available }) {
  const base = LANE_SPINE_Y + LANE_BELOW_SPINE;
  const want = Math.max(base, (Number.isFinite(contentBottom) ? contentBottom : 0) + 6);
  const cap = Math.max(base, Math.round((Number.isFinite(available) ? available : 0) * 0.6));
  return Math.min(want, cap);
}

/**
 * Keeps a label box on screen. The box is centred on its node at `x`; it slides right or left
 * just enough to stay inside [minX, maxX], but never so far that it stops overlapping its node.
 * A node outside the visible span gets no label at all (`hidden`).
 *
 * @returns {{ shift: number, hidden: boolean }}
 */
export function clampLabelShift(x, width, { minX = 0, maxX = Infinity, pad = 6 } = {}) {
  if (!Number.isFinite(x)) return { shift: 0, hidden: true };
  if (x < minX || x > maxX) return { shift: 0, hidden: true };
  const half = width / 2;
  const maxShift = half - 8;
  let shift = 0;
  if (x - half < minX + pad) shift = minX + pad - (x - half);
  else if (x + half > maxX - pad) shift = maxX - pad - (x + half);
  return { shift: Math.max(-maxShift, Math.min(maxShift, shift)), hidden: false };
}
